// Utils
import { generateKey } from "@/utils/cache";

const cache = new Map<string, unknown>();

export default {
  has(requestName: string, requestParams: unknown = null): boolean {
    const key = generateKey(requestName, requestParams);
    return cache.has(key);
  },

  set(requestName: string, data: unknown, requestParams: unknown = null): void {
    const key = generateKey(requestName, requestParams);
    cache.set(key, data);
  },

  get(requestName: string, requestParams: unknown = null): unknown {
    const key = generateKey(requestName, requestParams);
    return cache.get(key);
  },

  delete(requestName: string, requestParams: unknown = null): boolean {
    const key = generateKey(requestName, requestParams);
    return cache.delete(key);
  },

  clear(): void {
    cache.clear();
  },
};
